const STU_COURSE_IDS_KEY = "stu_course_ids";

export function setStuCourseIds(cntList = []) {
  const stuCourseIds = (Array.isArray(cntList) ? cntList : [])
    .map((item) => item?.title_info?.learn_stu_course_id)
    .filter((item) => item !== undefined && item !== null && item !== "");
  sessionStorage.setItem(STU_COURSE_IDS_KEY, JSON.stringify(stuCourseIds));
  return stuCourseIds;
}

export function getStuCourseIds() {
  try {
    const stuCourseIds = JSON.parse(
      sessionStorage.getItem(STU_COURSE_IDS_KEY) || "[]"
    );
    return stuCourseIds.join(",") || "";
  } catch (error) {
    return [];
  }
}

export function appendStuCourseIds(params = {}) {
  return {
    ...params,
    stu_course_ids: getStuCourseIds(), // 在读课id
  };
}

export function getRenewalData(
  contCourseData = {},
  { tabListIndex = -1, packageInfoIndex = -1, nextSelectType } = {}
) {
  const cntList = Array.isArray(contCourseData?.cnt_list)
    ? contCourseData.cnt_list
    : [];
  return cntList
    .filter((item, index) => {
      const titleInfo = item?.title_info || {};
      const packageInfoList = Array.isArray(item?.package_info)
        ? item.package_info
        : [];
      return packageInfoList.some((packageItem, pIndex) => {
        const currentSelectType =
          index === tabListIndex && pIndex === packageInfoIndex
            ? nextSelectType
            : packageItem?.selectType;
        if (+currentSelectType !== 2) {
          return false;
        }
        const productList = Array.isArray(packageItem?.product_list)
          ? packageItem.product_list
          : [];
        return productList.some((product) => {
          return (
            +product?.type === 100 &&
            [titleInfo?.cnt_course_id, titleInfo?.union_course_id]
              .filter((courseId) => courseId !== undefined && courseId !== null)
              .some((courseId) => String(product?.id) === String(courseId))
          );
        });
      });
    })
    .map((item) => {
      return {
        stu_course_id: item?.title_info?.learn_stu_course_id,
        cnt_course_id: item?.title_info?.cnt_course_id,
        union_course_id: item?.title_info?.union_course_id,
      };
    })
    .filter(Boolean);
}

// 埋点公参
export function getPublicParams() {
  return appendStuCourseIds({
    user_id: sessionStorage.getItem("uid") || "",
    course_id: "课程ID-包括在读课id、续报课id、联报课id",
    class_type: "1原班推荐2非原班推荐",
  });
}

export const publicParams = getPublicParams();
